import { SalesChannelModeWithSister } from '@/src/types/common/SalesChannel';
import i18n from '../i18n';
import { EnumModuleType } from '@/src/types/common/module';
const carouselTypeOptionsGenerator = ({
  salesChannelMode,
}: {
  salesChannelMode: SalesChannelModeWithSister;
}) => {
  const nonProductList = [
    SalesChannelModeWithSister.I_I,
    SalesChannelModeWithSister.I_Only,
  ];
  if (nonProductList.includes(salesChannelMode)) {
    return [
      {
        label: i18n['content.carouseltype.image'],
        value: EnumModuleType.ResponsiveImageCarousel,
      },
      {
        label: i18n['content.carouseltype.content'],
        value: EnumModuleType.ResponsiveContentCarousel,
      },
    ];
  } else {
    return [
      {
        label: i18n['content.carouseltype.image'],
        value: EnumModuleType.ResponsiveImageCarousel,
      },
      {
        label: i18n['content.carouseltype.content'],
        value: EnumModuleType.ResponsiveContentCarousel,
      },
      {
        label: i18n['content.carouseltype.product'],
        value: EnumModuleType.ResponsiveProductCarousel,
      },
    ];
  }
};

const tabTypeOptionsGenerator = ({
  salesChannelMode,
}: {
  salesChannelMode: SalesChannelModeWithSister;
}) => {
  const nonProductList = [
    SalesChannelModeWithSister.I_I,
    SalesChannelModeWithSister.I_Only,
  ];
  if (nonProductList.includes(salesChannelMode)) {
    return [
      {
        label: i18n['general.content.poster'],
        value: EnumModuleType.ResponsivePosterTab,
      },
      {
        label: i18n['content.carouseltype.content'],
        value: EnumModuleType.ResponsiveContentTab,
      },
    ];
  } else {
    return [
      {
        label: i18n['general.content.poster'],
        value: EnumModuleType.ResponsivePosterTab,
      },
      {
        label: i18n['content.carouseltype.content'],
        value: EnumModuleType.ResponsiveContentTab,
      },
      {
        label: i18n['content.carouseltype.product'],
        value: EnumModuleType.ResponsiveProductTab,
      },
    ];
  }
};

const gridTypeOptionsGenerator = ({
  salesChannelMode,
}: {
  salesChannelMode: SalesChannelModeWithSister;
}) => {
  const nonProductList = [
    SalesChannelModeWithSister.I_I,
    SalesChannelModeWithSister.I_Only,
  ];
  if (nonProductList.includes(salesChannelMode)) {
    return [
      {
        label: i18n['content.carouseltype.content'],
        value: EnumModuleType.ResponsiveContentGrid,
      },
    ];
  } else {
    return [
      {
        label: i18n['content.carouseltype.content'],
        value: EnumModuleType.ResponsiveContentGrid,
      },
      {
        label: i18n['content.carouseltype.product'],
        value: EnumModuleType.ResponsiveProductGrid,
      },
    ];
  }
};

export {
  carouselTypeOptionsGenerator,
  gridTypeOptionsGenerator,
  tabTypeOptionsGenerator,
};
